<template>
  <el-row>
    <el-col>
      <ul class="left">
        <li>
          <router-link :to="windows ? '/home' : '/min'">
            <span>Home</span>
          </router-link>
        </li>
        <li v-if="$store.state.user.info && $store.state.user.info.permission === 'admin'">
          <router-link to="/raffle">
            <span>Raffle</span>
          </router-link>
        </li>
      </ul>
      <ul class="right">
        <li>
          <router-link to="/admin">
            <span>Admin</span>
          </router-link>
        </li>
        <li v-if="$store.state.user.info">
          <a href="javsscript:void(0);" @click="$store.commit('account.REMOVE')">
            <span>Logout</span>
          </a>
        </li>
      </ul>
      <br />
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    // logout() {
    //   console.log(`logout`)
    //   this.$store.commit("account.REMOVE");
    //   location.href = "/";
    // }
  },
  data() {
    return {
      windows: /windows/gi.test(navigator.userAgent)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
br {
  clear: both;
}
.el-row {
  max-width: 1220px;
  margin: auto;
  padding: 0 10px;
}
a {
  line-height: 40px;
  height: 40px;
  padding: 10px 0;
  text-decoration: none;
  display: block;
}
a span {
  color: #ccc;
  font-size: 16px;
  display: table-cell;
  vertical-align: middle;
  font-weight: bold;
}
a i {
  color: #ccc;
  font-size: 30px;
  display: table-cell;
  vertical-align: middle;
  line-height: 40px;
}
.el-dropdown-link {
  display: block;
  cursor: pointer;
}
.el-dropdown-link img {
  float: left;
  background: #ccc;
  width: 30px;
  height: 30px;
  border-radius: 5px;
  margin: 5px 0;
  overflow: hidden;
  display: table-cell;
  vertical-align: middle;
}
.el-dropdown-link i {
  float: left;
  line-height: 40px;
  display: table-cell;
  vertical-align: middle;
}
.el-dropdown-link:hover i.iconfont {
  color: #333;
}
a:hover span,
a:hover i,
a.router-link-active span,
a.router-link-active i {
  color: #333;
}
i.iconfont {
  font-size: 24px;
}
.el-badge {
  height: 40px;
  width: 24px;
}
.el-badge i {
  position: absolute;
  top: -2px;
}
ul {
  list-style: none;
  /* height: 60px; */
}
a:hover i.logo,
i.logo,
a.router-link-active i.logo {
  color: #4898f8;
  font-size: 30px;
  padding-right: 10px;
}
.iconfont {
  color: #999;
}
ul.left {
  float: left;
  height: 60px;
}
ul.left li {
  padding-left: 10px;
  /* height: 60px; */
}
ul.left li:first-child {
  padding-left: 0;
}
ul.right {
  float: right;
}
ul.right li {
  padding-left: 10px;
}
ul.right.no li {
  padding-left: 10px;
}
ul.left li,
ul.right li {
  display: inline-block;
  /* line-height: 60px; */
  display: table-cell;
  vertical-align: middle;
}
menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #333;
  color: #fff;
}

.el-row {
  padding: 0;
}

@media (max-width: 700px) {
  ul.right {
    float: none;
  }

  ul.right li {
    padding-left: 5px;
  }

  ul.left li {
    padding-left: 5px;
  }
}
</style>
